import useAppMethods from '../../hooks/utility/useAppMethods';
import classnames from 'classnames';

interface Props {
  actualPrice: number;
  originalPrice: number;
  hideDiscount?: boolean;
  actualPriceStyle?: object;
  originalPriceStyle?: object;
  className?: string;
}

export default function PriceComparison(props: Props) {
  const { actualPrice, originalPrice, hideDiscount, actualPriceStyle, originalPriceStyle, className } = props;

  const { formatCurrency } = useAppMethods();

  const isDiscount: boolean = !hideDiscount && actualPrice < originalPrice;

  return (
    <div className={classnames(priceContainer, className)}>
      {isDiscount && (
        <p className={strikethroughPriceStyle} style={originalPriceStyle}>
          {formatCurrency(originalPrice)}
        </p>
      )}
      <p className={priceStyle(isDiscount)} style={actualPriceStyle}>
        {formatCurrency(actualPrice)}
      </p>
    </div>
  );
}

const priceContainer = 'flex flex-row items-center justify-end inline-flex';

const strikethroughPriceStyle = 'text-muted-foreground line-clamp-1 text-right text-sm line-through mr-xs';

const priceStyle = (isDiscount?: boolean) =>
  classnames('text-right line-clamp-1', {
    'text-sm text-brand-primary font-medium text-orange-400': isDiscount,
    'text-default': !isDiscount,
  });
